import { render, staticRenderFns } from "./baoyue.vue?vue&type=template&id=76fb534e&scoped=true"
import script from "./baoyue.vue?vue&type=script&lang=js"
export * from "./baoyue.vue?vue&type=script&lang=js"
import style0 from "./baoyue.vue?vue&type=style&index=0&id=76fb534e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fb534e",
  null
  
)

export default component.exports